module.exports = __webpack_public_path__ + "img/integrador_de_dados_img1.68028a1c.jpg";